import {post} from '../utils/request'

export default {
    getAll: function (query, paginate) {
        return post("/admin/enterprise/list", {...query, ...paginate});
    },
    getAll2: function (query) {
        return post("/admin/enterprise/listAll", {});
    },
    findById: function (id) {
        return post("/admin/enterprise/show", {id});
    },
    findLast: function() {
        return post("/admin/enterprise/last", {});
    },
    create: function (device) {
        return post("/admin/enterprise/create", device);
    },
    update: function (device) {
        return post("/admin/enterprise/update", device);
    },

    deleteById: function (id) {
        return post("/admin/enterprise/delete", {id});
    },
}
